exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AdditionalBalances_noWrapCell_1Z0Q {\n  white-space: nowrap\n}\n\n.AdditionalBalances_noWrapCell_1Z0Q:last-child {\n  width: 1px;\n}\n\n.AdditionalBalances_sasTextCell_1CWZ {\n  vertical-align: middle;\n}\n\n.AdditionalBalances_sasError_2NPF {\n  color: #fc4a4a;\n}\n\n@media (min-width: 768px) {\n\n  .AdditionalBalances_sasButtonCell_1XPE {\n    text-align: right\n  }\n}\n\n@media (max-width: 767px) {\n\n  .AdditionalBalances_sasButtonCell_1XPE {\n    padding-top: 20px !important\n  }\n}\n", ""]);

// exports
exports.locals = {
	"noWrapCell": "AdditionalBalances_noWrapCell_1Z0Q",
	"sasTextCell": "AdditionalBalances_sasTextCell_1CWZ",
	"sasError": "AdditionalBalances_sasError_2NPF",
	"sasButtonCell": "AdditionalBalances_sasButtonCell_1XPE"
};